import socketIOClient from "socket.io-client";
import { getApiUrl } from '../redux/actions/Api';

export const socket = socketIOClient(getApiUrl(), {pingTimeout: 60000, pingInterval: 10000});